import { ComponentNavigationComponentProps } from "@organisms/ComponentNavigation/ComponentNavigationComponent/ComponentNavigationComponent.types"
import { ComponentNavigation } from "@organisms/index"

export default function PopoverView(props: ComponentNavigationComponentProps) {
    const { componentId, children } = props

    return <ComponentNavigation.Component componentId={componentId}>{children}</ComponentNavigation.Component>
}
